import SEO from "components/seo"
import useTranslations from "hooks/useTranslations"
import UkHero from "./Hero"
import UkVideoIntro from "./VideoIntro"
import UkThreats from "./Threats"
import UkCarousel from "./Carousel"
import UkTestimonials from "./Testimonials"
import UkIntegrations from "./Integrations"
import UkCtaSection from "./CtaSection"

/**
 * The UK schools page, served at /schools on the global build only.
 *
 * Section order follows Essi's Tab 3 spec, which annotates a screenshot of
 * each section of the previous draft with what to do to it.
 *
 * Wall.tsx, CurriculumCoverage.tsx and Faq.tsx are still in this folder but no
 * longer rendered. The first two were marked "remove section" in Tab 3; the
 * FAQ came out on Kaisa's note that its answers describe only one part of the
 * product and had not been checked, with Jasmina's "remove if it's not ready,
 * we can add it later". The coverage table is the only evidence behind the
 * RSHE 2025 claim the copy still makes, so expect it back.
 *
 * Backgrounds alternate mint / black / white so no two adjacent bands share
 * a ground: mint, black, white, mint, black, white, black. Mint rather than the
 * schools segment's yellow because the UK sales deck is mint-dominant, and this
 * page has to look like the deck the rep just presented.
 */
export default function UkSchoolsPage() {
  const { ukSchoolsSeoTitle } = useTranslations()

  return (
    <div>
      <SEO title={ukSchoolsSeoTitle} />
      <UkHero />
      <UkVideoIntro />
      <UkThreats />
      <UkCarousel />
      <UkTestimonials />
      <UkIntegrations />
      <UkCtaSection />
    </div>
  )
}
